import { Component } from '@angular/core';

@Component({
  selector: 'app-municipios',
  standalone: true,
  imports: [],
  templateUrl: './municipios.component.html',
  styleUrl: './municipios.component.scss'
})
export class MunicipiosComponent {

}
